import axios from 'axios'

export default {
    login: (data) => axios.post('login', data),
    validate: (data) => axios.post('login/validate', data),
}